<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    @error-load="showError"
                    tableClass="table-responsive-sm table-auto">
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle"
                                    />
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <td :class="table.columns[0].class">
                            {{ columnValue(row, table.columns[0]) }}
                        </td>
                        <td :class="table.columns[1].class">
                            <template v-if="table.columns[1].route">
                                <router-link
                                    target='_blank'
                                    :to="table.columns[1].route(row, table.columns[1])">
                                    {{ columnValue(row, table.columns[1]) }}
                                </router-link>
                            </template>
                            <template v-else>
                                {{ columnValue(row, table.columns[1]) }}
                            </template>
                        </td>
                        <td :class="table.columns[2].class">
                            {{ columnValue(row, table.columns[2]) }}
                        </td>
                        <td :class="table.columns[3].class">
                            {{ columnOnOff(row, table.columns[3]) }}
                        </td>
                        <td :class="table.columns[4].class">
                            {{ columnOnOff(row, table.columns[4]) }}
                        </td>
                        <column-actions
                            v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove"
                        />
                    </template>
                </table-data>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import GeneralMixin from '../../mixin';

    export default {
        mixins: [GeneralMixin],
        data() {
            let pageID = 'pages';
            return {
                pageID: pageID,
                table: {
                    settings: {
                        sort: 'asc',
                        order_by: 'order',
                    },
                    columns: [
                        {
                            label: this.$t(`${pageID}.list.order`),
                            field: 'order',
                            sortable: true,
                            class: 'w-100px',
                        },
                        {
                            label: this.$t(`${pageID}.list.title`),
                            field: 'title',
                            fieldUrl: 'redirect',
                            fieldParam: 'slug',
                            route: (row, data) => {
                                let _key = data.fieldParam;
                                let _val =  this.columnValue(row, data, _key);
                                let params = {};
                                params[_key] = _val;
                                return this.getRouterLinkFromPage(row, params, data.fieldUrl);
                            },
                            sortable: true,
                        },
                        {
                            label: this.$t(`${pageID}.list.type`),
                            field_label: 'type.title',
                            sortable: true,
                        },
                        {
                            label: this.$t(`${pageID}.list.published`),
                            field: 'published',
                            sortable: true,
                            class: 'w-100px text-center',
                        },
                        {
                            label: this.$t(`${pageID}.list.footer`),
                            field: 'on_footer',
                            sortable: true,
                            class: 'w-100px text-center',
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
            }
        },
    }
</script>
